import React from 'react';
import { Link } from 'react-router-dom';
import { func, number, string } from 'prop-types';
import moment from "moment";
import pluralize from "pluralize";

import cx from 'classnames';
import s from './ConversationPreview.css';

const ConversationPreview = ({ conversationHash, conversationTitle, messageCount, message, messageTimestamp, attachmentsCount, switchConversation }) => {

    function formatTimestamp() {

        // If the message doesn't have a time stamp (typically when the conversation has no messages)
        // don't display anything.
        if (!messageTimestamp) {
            return '';
        }

        // If the message timestamp is from today then only display the time. Otherwise display
        // the fully formatted timestamp.
        const timestampFormat = moment(messageTimestamp).isSame(moment(), 'day') ? "h:mm A" : "ddd MMM D, YYYY";
        return moment(messageTimestamp).format(timestampFormat);
    }

    function renderEmptyMessageText() {
        return <i>Empty message sent with {attachmentsCount} {pluralize('attachment', attachmentsCount)}.</i>
    }

    function formatMessageCount() {
        return messageCount + " " + pluralize('message', messageCount);
    }

    // TODO call switchConversation
    // TODO animated transition before navigating to chat (future ticket)
    return (
        <Link className={s.component} to={'#'}
              onClick={() => switchConversation(conversationHash)}>
            <section className={cx(s.flexRow, s.heading)}>
                {conversationTitle &&
                    <p>
                        <span className={s.conversationTitle}>{conversationTitle}</span>
                        <span className={s.messageCount}>{formatMessageCount()}</span>
                    </p>
                }
                {!conversationTitle &&
                    <p className={s.conversationTitle}>
                        {formatMessageCount()}
                    </p>
                }
                <p className={cx(s.bold, s.timestamp)}>
                    {formatTimestamp()}
                </p>
            </section>
            <section className={s.truncated}>
                {message &&
                    <p className={s.messageText}>
                        {message}
                    </p>
                }
                {!message &&
                    <p className={cx(s.messageText, s.empty)}>
                        {renderEmptyMessageText()}
                    </p>
                }
            </section>
        </Link>
    );
};

ConversationPreview.propTypes = {
    conversationHash: string.isRequired,
    conversationTitle: string,
    messageCount: number.isRequired,
    message: string,
    messageTimestamp: string,
    attachmentsCount: number,
    switchConversation: func.isRequired,
};

export default ConversationPreview;
